export const GUID_PARAM = "guid" as const;
export const PRICELIST_ID_PARAM = "pricelistid" as const;
export const VAT_PARAM = "vat" as const;
export const DESIGN_TEMPLATE_PARAM = "designtemplate" as const;
export const ARTICLE_PARAM = "article" as const;
export const LAN_PARAM = "lan" as const;
export const COUNTRY_CODE_PARAM = "countrycode" as const;
export const UNIT_SYSTEM_PARAM = "unitsystem" as const;
export const AUTO_CAMERA_FOCUS_PARAM = "autocamerafocus" as const;
export const WEBGPU_PARAM = "webgpu" as const;

export const DEFAULT_GUID = "sit_NzE0MzczMTc0MDA";
